import React, { useState, useEffect } from "react";
import ApprovedContractorsHeader from "./ApprovedContractorsHeader.jsx";
import { getApprovedContractorsList } from "../../api/approvedContractors.js";
import ApprovedContractorList from "./ApprovedContractorsList.jsx";
import { GENERIC_ERROR_STRING } from "../../constants.js";

import "../../styles/approvedContractors.less";

export default function ApprovedContractors() {
  /** @type {[ApprovedContractor[], React.Dispatch<React.SetActionState<ApprovedContractor[]>>]} */
  const [approvedContractorListData, setApprovedContractorList] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "SEWP Approved Support Service Contractors";
    getApprovedContractorsList()
      .then((approvedContractorListData) => {
        setApprovedContractorList(approvedContractorListData);
      })
      .catch((error) => {
        setError(error);
      });
  }, []);

  if (error) {
    return <div id="approved-contractors-wrapper" className="container-fluid">{GENERIC_ERROR_STRING}</div>;
  } else if (!approvedContractorListData.length) {
    return <div id="approved-contractors-wrapper" className="container-fluid">Loading Approved Contractors Data...</div>;
  } else {
    return (
      <div id="approved-contractors-wrapper" className="container-fluid approved-contractors">
        <ApprovedContractorsHeader />
        <ApprovedContractorList
          approvedContractorsListData={approvedContractorListData}
        />
      </div>
    );
  }
}
